import Head from 'next/head';

import {
    colors
} from '../../styles/_colors';
import SunnysideHeader from '../../components_sunnyside/header';
import CookiePolicy from '../../sections/cookies/cookie_policy';
import BrightestSection from '../../sections/reusable/brightest';
import FooterFeatured from '../../sections/reusable/footer_featured';
import SunnysideFooter from '../../components_sunnyside/footer';
import {
    GetStaticProps, InferGetStaticPropsType
} from 'next';
import TrackingScripts from '../../sections/trackingScripts';
import {
    PrismicPaginatedResponse
} from '../../utils/prismic/types';
import prismic from '../../utils/prismic';
import {
    PrismicBasicPageResponseData
} from '../../utils/prismic/types/pages/basic.type';
import SunnysideWrapper from '../../components_sunnyside/wrapper';
import SunnysideMain from '../../components_sunnyside/main';

export const getStaticProps: GetStaticProps = async () => {
    const data: PrismicPaginatedResponse<PrismicBasicPageResponseData> = await prismic()
        .getByUid('basic_page', 'cookies');
    return {
        props: {
            data,
            metaData: {
                ogTitle: 'Sunnyside',
                ogSiteName: 'Sunnyside',
                ogUrl: 'https://www.sunnyside.com/cookies',
                ogDescription: '',
                ogImage: 'https://images.prismic.io/sunnysidetest/63e6349a-7e7b-4ce2-9841-54c570ebcda7_sunnyside-og.jpg?auto=compress,format',
                title: data.results[0].data.meta_title,
                disableNoIndex: true,
            }
        },
        revalidate: 30
    };
};

export default function CookiesPage({
    data
}: InferGetStaticPropsType<typeof getStaticProps>): JSX.Element {
    const document = data.results[0];

    return (
        <SunnysideWrapper>
            <TrackingScripts />
            <Head>
                <meta
                    name="description"
                    content={document.data.meta_description}
                />
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />
                <meta
                    name="twitter:title"
                    content="Sunnyside"
                />
                <meta
                    name="twitter:description"
                    content=""
                />
                <meta
                    name="twitter:image"
                    content="https://images.prismic.io/sunnysidetest/b2fc85a6-8ff8-4809-942e-7d436eb35dae_sunnyside-og.png"
                />
                <meta
                    name="twitter:site"
                    content="@joinsunnyside"
                />
                <meta
                    name="twitter:creator"
                    content="@joinsunnyside"
                />
            </Head>
            <SunnysideHeader bgcolor={colors.cloud}/>
            <SunnysideMain>
                <CookiePolicy cookiePolicy={document}/>
                <BrightestSection />
                <FooterFeatured />
            </SunnysideMain>
            <SunnysideFooter />
        </SunnysideWrapper>
    );
}
